import { Card } from '@/components/ui/card';

export const TransactionsTab = ({ donations }) => (
  <Card className="card-tech p-6" data-testid="transactions-tab">
    <h3 className="text-xl font-bold text-green-400 mb-4">All Transactions ({donations.length})</h3>
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="border-b border-green-500/20">
            <th className="text-left text-green-400 py-3 px-2">Date</th>
            <th className="text-left text-green-400 py-3 px-2">Payment ID</th>
            <th className="text-left text-green-400 py-3 px-2">Email</th>
            <th className="text-left text-green-400 py-3 px-2">Tier</th>
            <th className="text-right text-green-400 py-3 px-2">Amount</th>
          </tr>
        </thead>
        <tbody>
          {donations.map((d, idx) => (
            <tr key={`${d.payment_id || d.id || d.timestamp}-${idx}`} className="border-b border-green-500/10">
              <td className="py-3 px-2 text-green-300 text-sm">{(d.timestamp || '').slice(0, 16)}</td>
              <td className="py-3 px-2 text-green-300 text-xs font-mono">{(d.payment_id || '').slice(0, 20)}...</td>
              <td className="py-3 px-2 text-green-300 text-sm">{d.email || 'N/A'}</td>
              <td className="py-3 px-2">
                <span className={`px-2 py-1 rounded text-xs font-bold ${d.tier === 'pro' ? 'bg-green-500/20 text-green-400' : 'bg-green-500/10 text-green-500'}`}>
                  {(d.tier || 'basic').toUpperCase()}
                </span>
              </td>
              <td className="py-3 px-2 text-right text-green-300 font-mono">${(d.amount || 0).toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </Card>
);
